import type { TestFunction } from 'yup';

export const validateUrl: TestFunction<string | null | undefined> = (
  value?: string | null,
) => {
  try {
    if (value) {
      new URL(value);
    }
  } catch (_err) {
    return false;
  }
  return true;
};

export const validateOriginPattern: TestFunction<string | null | undefined> = (
  value?: string | null,
) => {
  if (value == null) {
    return true;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }
  if (trimmed === '*') {
    return true;
  }
  if (!/^https?:\/\//i.test(trimmed)) {
    return false;
  }
  if (/[?#]/.test(trimmed)) {
    return false;
  }
  const withoutScheme = trimmed.replace(/^https?:\/\//i, '');
  if (withoutScheme.includes('/') || withoutScheme.includes('@')) {
    return false;
  }
  return true;
};
